<mat-toolbar color="primary">
  <span class="example-spacer"></span>

  <button
    [routerLink]="'/secure/broker-messages'"
    (click)="getMyMessages()"
    class="messages-circle-btn"
    mat-raised-button
    fxHide.gt-xs
    aria-label="My Messages"
  >
    <cigna-icon class="bell-icon"></cigna-icon>
  </button>
  <button
    [routerLink]="'/secure/broker-messages'"
    (click)="getMyMessages()"
    class="messages-button"
    mat-raised-button
    fxHide.lt-sm
  >
    <cigna-icon class="bell-icon"></cigna-icon>
    <span class="messages-button-text">{{
      'broker.mymessages' | translate
    }}</span>
  </button>
  <button
    mat-button
    class="icon-wrap"
    data-test-id="btnHiddenResToggleBtn"
    tabindex="0"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    (click)="menuTrigger.openMenu()"
    *ngIf="true"
    fxHide.gt-md
  >
    <div class="header-icon hamburger-icon"></div>
  </button>
  <a
    class="brportal-right-nav-wrap topHeadItem topHeadLastItem"
    data-test-id="linkLoginInfo"
    tabindex="0"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    (focus)="menuTrigger.openMenu()"
  >
    <div class="logininfo-icon-wrapper">
      <div class="logininfo-icon">
        <div data-test-id="lblLoginDetailCircle">
          {{
            (firstName ? firstName : internalFirstName)
              ?.trim()
              .substring(0, 1)
              .toUpperCase()
          }}{{
            (lastName ? lastName : internalLastName)
              ?.trim()
              .substring(0, 1)
              .toUpperCase()
          }}
        </div>
      </div>
    </div>
    <div class="logininfo-name" data-test-id="lblLoginName">
      {{ firstName ? firstName : internalFirstName }}
      {{ lastName ? lastName : internalLastName }}
      <span class="logininfo-name-selection">
        <cigna-icon [type]="'chevron-thin-down'"></cigna-icon>
      </span>
    </div>
  </a>
  <mat-menu
    #menu="matMenu"
    class="top-right-nav-tablet-width"
    data-test-id="drpLoginMenu"
    [class]="'brportal-topnav-wrap'"
    [ngClass]="isCloseIconClicked ? 'hideMenu' : 'showMenu'"
  >
    <ng-container>
      <div class="close-icon-container" fxHide.gt-xs>
        <button mat-button class="icon-wrap float-r" (click)="closeIcon()">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="close-text">{{ 'global.close' | translate }}</div>
            <div class="header-icon close-icon"></div>
          </div>
        </button>
      </div>
      <cigna-caprimary-nav
        *ngIf="!isContactUsIntuitive(currentUrlPath)"
        fxHide.gt-md
        [menuItemsWithSubMenu]="menuItemsWithSubMenu"
        [navigationEntitlements]="navigationEntitlements"
        [sideBarToggleFlag]="false"
        [isScreenSmall]="false"
        [attr.data-test-id]="'snPrimaryComponentContainer'"
        [resizeSideNavToggle]="false"
        [source]="source"
        (appRedirect)="appRedirect($event)"
        [isImpersonatorFlag]="isImpersonatorFlag"
        (windowOpen)="navigateSecureMessageLayout($event)"
        (closeMenuEmitter)="closeMenu()"
      ></cigna-caprimary-nav>
      <mat-divider class="divider-spacer" fxHide.gt-md></mat-divider>
    </ng-container>
    <ng-container>
      <button
        mat-menu-item
        data-test-id="btnLoginMenuSecurityProfile"
        tabindex="0"
        *ngIf="hasSecurityProfile && !isUseOnly"
        (click)="securityProfile()"
      >
        {{ 'header.securityProfile' | translate }}
      </button>

      <button
        mat-menu-item
        data-test-id="btnLoginMenuSecurityProfile"
        tabindex="0"
        *ngIf="hasSecurityProfile && isUseOnly"
        (click)="securityProfile()"
      >
        {{ 'header.securityProfile1' | translate }}
      </button>

      <button
        mat-menu-item
        data-test-id="btnLoginMenuContact"
        tabindex="0"
        *ngIf="hasContactInfo"
        (click)="profileContactUS()"
      >
        {{ 'header.contact' | translate }}
      </button>
    </ng-container>
    <button
      mat-menu-item
      (click)="processLogout()"
      *ngIf="hasLogout"
      data-test-id="btnLoginMenuLogout"
      tabindex="0"
    >
      {{ 'header.logout' | translate }}
    </button>
  </mat-menu>
</mat-toolbar>
